import Dashboard from "../views/Dashboard/Dashboard";
import Profile from "../views/Profile";
import InActiveUsers from "../views/Users/InActiveUsers";
import EditUser from "../views/Users/EditUser";
import ViewUser from "../views/Users/ViewUser";
import Users from "../views/Users/Users";
import Services from "../views/Services/Services";
import ViewService from "../views/Services/ViewService";
import EditService from "../views/Services/EditService";
import AddService from "../views/Services/AddService";
import ServicePreview from "../views/Services/ServicePreview";
import Orders from "../views/Orders/Orders";
import OrderDetails from "../views/Orders/OrderDetails";
import StyleGuides from "../views/StyleGuides/StyleGuides";
import StyleGuideDetails from "../views/StyleGuides/StyleGuideDetails";
import ViewStyleGuide from "../views/StyleGuides/ViewStyleGuide";
import AddStyleGuide from "../views/StyleGuides/AddStyleGuide";
import EditStyleGuide from "../views/StyleGuides/EditStyleGuide";
import OurWorks from "../views/OurWork/OurWorks";
import AddOurWork from "../views/OurWork/AddOurWorkGuide";
import ViewOurWork from "../views/OurWork/ViewOurWork";
import EditOurWork from "../views/OurWork/EditOurWork";
import TermsAndConditions from "../views/Content/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "../views/Content/PrivacyPolicy/PrivacyPolicy";
import FAQ from "../views/Content/FAQ/FAQ";
import Contacts from "../views/Contacts/Contacts";
import ViewContact from "../views/Contacts/ViewContact";
import Enquiries from "../views/Enquiries/Enquiries";
import ViewEnquiry from "../views/Enquiries/ViewEnquiry";
import OurClients from "../views/OurClients/OurClients";
import ViewOurClient from "../views/OurClients/ViewOurClient";
import EditOurClient from "../views/OurClients/EditOurClient";
import AddOurClient from "../views/OurClients/AddOurClient";

export const AppRoutes = [
    {
        path: "/dashboard",
        name: "Dashboard",
        component: Dashboard,
        exact: true,
    },
    {
        path: "/inactive-users",
        name: "InActive users",
        component: InActiveUsers,
        exact: true,
    },
    {
        path: "/users",
        name: "Users",
        component: Users,
        exact: true,
    },
    {
        path: "/users/view/:id",
        name: "View Users",
        component: ViewUser,
        exact: true,
    },
    {
        path: "/users/edit/:id",
        name: "Edit Users",
        component: EditUser,
        exact: true,
    },
    {
        path: "/services",
        name: "Services",
        component: Services,
        exact: true,
    },
    {
        path: "/services/add",
        name: "Add Service",
        component: AddService,
        exact: true,
    },
    {
        path: "/services/preview",
        name: "Preview Services",
        component: ServicePreview,
        exact: true,
    },
    {
        path: "/services/view/:id",
        name: "View Services",
        component: ViewService,
        exact: true,
    },
    {
        path: "/services/edit/:id",
        name: "Edit Services",
        component: EditService,
        exact: true,
    },
    {
        path: "/orders",
        name: "Orders",
        component: Orders,
        exact: true,
    },
    {
        path: "/orders/details/:id",
        name: "Orders Details",
        component: OrderDetails,
        exact: true,
    },
    {
        path: "/style-guides",
        name: "Style Guides",
        component: StyleGuides,
        exact: true,
    },
    {
        path: "/style-guides/add",
        name: "Add Style",
        component: AddStyleGuide,
        exact: true,
    },
    {
        path: "/style-guides/view/:id",
        name: "View Style",
        component: ViewStyleGuide,
        exact: true,
    },
    {
        path: "/style-guides/edit/:id",
        name: "Edit Style",
        component: EditStyleGuide,
        exact: true,
    },
    {
        path: "/our-works",
        name: "Our Works List",
        component: OurWorks,
        exact: true,
    },
    {
        path: "/our-works/add",
        name: "Add Work",
        component: AddOurWork,
        exact: true,
    },
    {
        path: "/our-works/view/:id",
        name: "View Work",
        component: ViewOurWork,
        exact: true,
    },
    {
        path: "/our-works/edit/:id",
        name: "Edit Work",
        component: EditOurWork,
        exact: true,
    },
    {
        path: "/content/terms-and-conditions",
        name: "Terms and Conditions",
        component: TermsAndConditions,
        exact: true,
    },
    {
        path: "/content/privacy-policy",
        name: "Privacy Policy",
        component: PrivacyPolicy,
        exact: true,
    },
    {
        path: "/content/faq",
        name: "FAQ",
        component: FAQ,
        exact: true,
    },
    {
        path: "/contacts/",
        name: "Contacts",
        component: Contacts,
        exact: true,
    },
    {
        path: "/contacts/view/:id",
        name: "View Contact",
        component: ViewContact,
        exact: true,
    },
    {
        path: "/enquiries/",
        name: "Enquiries",
        component: Enquiries,
        exact: true,
    },
    {
        path: "/enquiries/view/:id",
        name: "View Enquiry",
        component: ViewEnquiry,
        exact: true,
    },
    {
        path: "/our-clients",
        name: "Users",
        component: OurClients,
        exact: true,
    },
    {
        path: "/our-clients/add",
        name: "Add Our Clients",
        component: AddOurClient,
        exact: true,
    },
    {
        path: "/our-clients/view/:id",
        name: "View Our Clients",
        component: ViewOurClient,
        exact: true,
    },
    {
        path: "/our-clients/edit/:id",
        name: "Edit Our Clients",
        component: EditOurClient,
        exact: true,
    },
    {
        path: "/settings",
        name: "Settings",
        component: Profile,
        exact: true,
    },
];
